import axios from 'axios';

let baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5003';
if (baseUrl.endsWith('/api')) {
  baseUrl = baseUrl.slice(0, -4);
}
const API_URL = `${baseUrl}/api`;

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  // Try to get the token from localStorage
  let token = localStorage.getItem('token');
  // If not found in localStorage, try sessionStorage
  if (!token) {
    token = sessionStorage.getItem('token');
  }
  // If not found in sessionStorage, try to get from cookie
  if (!token) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'token') {
        token = value;
        break;
      }
    }
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for global error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      // Also clear the token cookie by setting it to expire in the past
      document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;